const oidc = JSON.parse(process.env.VUE_APP_OIDC_CONFIG);

if (process.env.NODE_ENV !== 'development') {
  oidc.authority = window.location.origin;
  oidc.redirectUri = window.location.origin + '/oidc-callback';
  oidc.postLogoutRedirectUri = window.location.origin;
  oidc.silentRedirectUri = window.location.origin + '/silent-renew-oidc.html';
}

export const oidcSettings = oidc;
